import { Component, Input, Output, EventEmitter } from "@angular/core";
@Component({
    selector: "app-buttonFuentesMenu",
    templateUrl: "./buttonFuentesMenu.component.html",
    styleUrls: ["./buttonFuentesMenu.component.scss"],
    standalone: false
})
export class ButtonFuentesMenuComponent {
  @Input() menuData: { title: string; route: string } = null;
  @Output() onFuenteClic: EventEmitter<string> = new EventEmitter();

  onClickGotToSource(route: string) {
    this.onFuenteClic.emit(route)
  }

}
